export class Dibels8ZoGClient {
    static BASE_URL = '/dibels8-api/zones-of-growth';

    static STUDENT_GOALS_URL = `${Dibels8ZoGClient.BASE_URL}/student_goals`;

    constructor(httpClient) {
        this.httpClient = httpClient;
    }

    /**
     * Constructs requests header structure
     * @param {String} token - keycloak token
     */
    getRequestHeaders = token => (token ? { authorization: `Bearer ${token}` } : {});

    /**
     * Get teacher set goals for a list of students in a particular school year.
     * @param {Array<String>} studentUids List of student ids. Should be not empty.
     * @param {String} [schoolYear] School year to get results. If not provided, all years are included.
     * @param token keycloak token
     * @returns {Promise}
     */
    async getStudentGoals(studentUids, schoolYear, token) {
        const headers = this.getRequestHeaders(token);
        return this.httpClient.get(Dibels8ZoGClient.STUDENT_GOALS_URL, {
            params: { studentUids: studentUids.join(','), schoolYear },
            headers,
        });
    }
}

export default Dibels8ZoGClient;
